import {  Edit } from "@mui/icons-material";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Typography,
  Grid
} from "@mui/material";
import { PremiumTextField } from "../PremiumInputs";
import { useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { editCustomerDetails } from "../../firebase/dataHandler";

function EditCustomerForm({customerId, refresh, buttonText, style, customerDetails}) {
  const [open, setOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validationSchema = yup.object({
    name: yup.string().required().min(3),
    surName:yup.string().min(3),
    townName: yup.string().required(),
    contact: yup.string().matches(/^([0-9]{10})/),
    altContact: yup.string().matches(/^[0-9]{10}/),
  });

  const formValues = {
    name: customerDetails.name || "",
    surName: customerDetails.surName || "",
    townName: customerDetails.townName || "",
    contact: customerDetails.contact || "",
    altContact: customerDetails.altContact || "",
    idProof:  customerDetails.idProof || "" ,
  };

  return (
    <div>
      <IconButton size="small" style={style} color="inherit" onClick={handleClickOpen}>
        <Edit /> {buttonText}
      </IconButton>
      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16,
            background: 'var(--bg-card)',
            border: '1px solid var(--border-subtle)',
          }
        }}
      >
        <LinearProgress hidden={!isLoading} sx={{ height: 3, '& .MuiLinearProgress-bar': { background: 'linear-gradient(90deg, #15C358, #109441)' } }} />
        <DialogTitle sx={{ pb: 1, borderBottom: '1px solid var(--border-subtle)', mb: 2 }}>
          <Typography sx={{ fontWeight: 800, fontSize: 18, color: 'var(--text-primary)', fontFamily: 'Inter' }}>
            Edit Customer Details
          </Typography>
          <Typography sx={{ fontSize: 13, color: 'var(--text-muted)', fontFamily: 'Inter' }}>
            Modify profile information
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Formik
            initialValues={formValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              setLoading(true)
              editCustomerDetails(customerId, values).then((result)=>{
                actions.setSubmitting(false)
                setLoading(false)
                actions.resetForm()
                refresh && refresh()
                handleClose()
              }).catch(err=>{
               alert(err)
              })
            }}
          >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
              <form>
                {Object.keys(formValues).map(val=>errors[val] && touched[val] && <Alert severity="error" sx={{mb: 2}}>{errors[val]}</Alert>)}
                
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <PremiumTextField
                      id="name"
                      label="First Name"
                      type="text"
                      required
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PremiumTextField
                      id="surName"
                      label="Last Name"
                      type="text"
                      value={values.surName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <PremiumTextField
                      id="townName"
                      label="Town/City Name"
                      type="text"
                      required
                      value={values.townName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <PremiumTextField
                      id="contact"
                      label="Mobile No."
                      type="tel"
                      value={values.contact}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 10, inputMode: 'numeric' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PremiumTextField
                      id="altContact"
                      label="Alt Mobile No."
                      type="tel"
                      value={values.altContact}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 10, inputMode: 'numeric' }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <PremiumTextField
                      id="idproof"
                      name="idProof"
                      label="Aadhar No. / PAN No."
                      type="text"
                      value={values.idProof}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>
                </Grid>

                <DialogActions sx={{ pt: 3, px: 0, pb: 0, borderTop: '1px solid var(--border-subtle)', mt: 3 }}>
                    <Button 
                      onClick={handleClose} 
                      sx={{ color: 'var(--text-muted)', fontFamily: 'Inter', fontWeight: 600, px: 3 }}
                    >
                      Cancel
                    </Button>
                    <Button 
                      type="submit" 
                      variant="contained" 
                      onClick={handleSubmit}
                      sx={{ 
                        fontFamily: 'Inter', fontWeight: 700, px: 4, py: 1, borderRadius: 2,
                        background: 'linear-gradient(135deg, #15C358, #109441)',
                        color: '#fff',
                        boxShadow: '0 4px 14px rgba(21, 195, 88, 0.4)',
                        '&:hover': { background: '#109441' }
                      }}
                    >
                      Save Changes
                    </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default EditCustomerForm;
